/* ==========================================================================
   Mini Maxx — document page
   One behaviour only: deep-linking to a question. Everything else about the
   FAQ is native <details>, which already works without this file.
   ========================================================================== */

(function () {
  'use strict';

  // Turn a question into a stable anchor so a support reply can link straight
  // at one answer, e.g. /pages/faq#why-do-i-have-error-294
  function slug(text) {
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60);
  }

  function openFromHash(root) {
    var hash = window.location.hash.replace('#', '');
    if (!hash) return;

    var target = root.querySelector('#' + CSS.escape(hash));
    if (!target || target.tagName.toLowerCase() !== 'details') return;

    target.open = true;
    target.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  function bind(root) {
    if (root.dataset.mmBound === 'true') return;
    root.dataset.mmBound = 'true';

    root.querySelectorAll('.mm-doc__faq').forEach(function (item) {
      var q = item.querySelector('.mm-doc__faq-q span');
      if (!q || item.id) return;
      item.id = slug(q.textContent || '');
    });

    openFromHash(root);
    window.addEventListener('hashchange', function () { openFromHash(root); });
  }

  function init() {
    document.querySelectorAll('[data-mm-doc]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
